import React from 'react';
import Sidebar from './Sidebar';
import { Box, Container } from '@mui/material';
// The Fleet Agent rings here (internet call) when a machine update is overdue.
import AgentCallCenter from '../agent/AgentCallCenter';

const MainLayout = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'var(--bg-main)',
                minHeight: '100vh',
                color: 'var(--text-main)',
                fontFamily: 'var(--font-sans)'
            }}
        >
            <Sidebar />
            <AgentCallCenter />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    pt: '72px', // Space for fixed top navbar
                    pb: 4,
                    overflowY: 'auto',
                    height: '100vh',
                }}
                className="scrollbar-hide"
            >
                <Container maxWidth={false} disableGutters sx={{ mt: 0, px: 0, display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ width: '100%' }}>
                        {children}
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default MainLayout;
